'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styles$h = require('./styles-20b982bf.js');

var Jumbotron = function (_a) {
    var imageUrl = _a.imageUrl, title = _a.title, subTitle = _a.subTitle, buttonText = _a.buttonText, onClick = _a.onClick, showChevron = _a.showChevron, chevronOnClick = _a.chevronOnClick;
    return (React__default.createElement(styles$h.Container, { imageUrl: imageUrl },
        React__default.createElement(styles$h.Content, null,
            React__default.createElement(styles$h.Title, null, title),
            React__default.createElement(styles$h.SubTitle, null, subTitle),
            React__default.createElement(styles$h.StyledButton, { text: buttonText, variant: constants.BUTTON_VARIANT.CLOSE_BUTTON, disabled: false, onClick: onClick })),
        showChevron && (React__default.createElement(styles$h.ChevronButton, { "data-testid": "chevronButton", onClick: chevronOnClick },
            React__default.createElement(styles$h.Icon, { icon: ['fas', 'chevron-down'] })))));
};

exports.Jumbotron = Jumbotron;
